// OIDC callback — exchanges the authorization code for tokens,
// then hands off to the auth store and redirects to the app.

import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleOidcCallback } from '../../auth/oidc';
import { useAuthStore } from '../../store/authStore';

export default function Callback() {
  const navigate    = useNavigate();
  const loginWith   = useAuthStore(s => s.loginWithOidc);
  const attempted   = useRef(false);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;

    handleOidcCallback()
      .then(tokens => loginWith(tokens))
      .then(() => navigate('/', { replace: true }))
      .catch((err: unknown) => {
        console.error('[auth/callback]', err);
        const msg = err instanceof Error ? err.message : 'Authentication failed';
        navigate(`/login?error=${encodeURIComponent(msg)}`, { replace: true });
      });
  }, [loginWith, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#DDDEDE',
      flexDirection: 'column',
      gap: 16,
    }}>
      <img src="/opengov_logo.png" alt="OpenGov" style={{ height: 36, opacity: 0.6 }} />
      <div style={{ color: '#64748b', fontSize: 14 }}>Signing you in…</div>
    </div>
  );
}
